export default "__VITE_ASSET__2s96f7Jd__"